import { GlTooltipDirective } from '@gitlab/ui';
import MrWidgetAuthor from './mr_widget_author.vue';
export default {
    name: 'MrWidgetAuthorTime',
    components: {
        MrWidgetAuthor
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        actionText: {
            type: String,
            required: true
        },
        author: {
            type: Object,
            required: true
        },
        dateTitle: {
            type: String,
            required: false,
            default: ''
        },
        dateReadable: {
            type: String,
            required: true
        }
    }
};
